// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function FingerprintIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M9 16a16.83 16.83 0 0 1-1.77 7.559 1 1 0 1 1-1.79-.89A14.85 14.85 0 0 0 7 16a8.967 8.967 0 0 1 3.375-7.025 1 1 0 1 1 1.25 1.561A6.971 6.971 0 0 0 9 16Zm7-1a1 1 0 0 0-1 1c0 3.896-.99 7.728-2.875 11.137a1 1 0 1 0 1.75.97A25.024 25.024 0 0 0 17 16a1 1 0 0 0-1-1Zm0-4a5 5 0 0 0-5 5 1 1 0 1 0 2 0 3 3 0 1 1 6 0 26.763 26.763 0 0 1-2.564 11.5 1.003 1.003 0 0 0 1.814.854A28.751 28.751 0 0 0 21 16a5 5 0 0 0-5-5Zm0-8A13.014 13.014 0 0 0 3 16a10.971 10.971 0 0 1-.625 3.666 1 1 0 1 0 1.886.666c.49-1.391.74-2.856.739-4.332a11 11 0 1 1 22 0c0 2.285-.221 4.564-.661 6.806A1.001 1.001 0 0 0 27.32 24a1 1 0 0 0 .98-.806c.466-2.37.7-4.78.7-7.194A13.015 13.015 0 0 0 16 3Zm-4.2 16.021a1 1 0 0 0-1.175.781 18.877 18.877 0 0 1-2.151 5.68 1 1 0 0 0 1.732 1 20.833 20.833 0 0 0 2.375-6.28 1.001 1.001 0 0 0-.781-1.18ZM16 7c-.376 0-.752.023-1.125.07a1 1 0 0 0 .25 1.984A7.01 7.01 0 0 1 23 16c0 1.295-.08 2.59-.24 3.875a.998.998 0 1 0 1.98.258 33.32 33.32 0 0 0 .25-4.125A9.01 9.01 0 0 0 16 7Zm7.241 16.031a1.002 1.002 0 0 0-1.218.719 32.777 32.777 0 0 1-.625 2.125 1 1 0 0 0 .943 1.319 1 1 0 0 0 .948-.683c.25-.74.473-1.5.668-2.256a1 1 0 0 0-.715-1.223Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
